// extracted by mini-css-extract-plugin
export default {"spinner_image":"c2a665","loading-spinner":"a278ac","spinner_wrapper":"c8fad8","ascii_spinner":"feccdd","ascii-spinner-animation":"eef587","show-spinner-animation":"e11de7"};